import React, { useState } from "react";
import { FaMapMarkerAlt, FaPhone, FaClock, FaSearch } from "react-icons/fa";

const LocateStorePage = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const stores = [
    {
      id: 1,
      city: "Bhabua",
      state: "Bihar",
      area: "Opposite West Gate of Police Station",
      address:
        "BRframes, Opposite West Gate of Police Station, Bhabua, Bihar 821101",
      phone: "+91 97097 99555",
      hours: "10 AM – 9 PM",
      mapEmbed:
        "https://maps.google.com/maps?q=BRframes%20opposite%20west%20gate%20of%20police%20station%20Bhabua%20Bihar%20821101&t=&z=15&ie=UTF8&iwloc=&output=embed",
      mapLink:
        "https://www.google.com/maps?q=BRframes+opposite+west+gate+of+police+station+Bhabua+Bihar+821101",
    },
  ];

  const filteredStores = stores.filter((store) => {
    const q = searchTerm.toLowerCase();
    return (
      store.city.toLowerCase().includes(q) ||
      store.area.toLowerCase().includes(q) ||
      store.address.toLowerCase().includes(q)
    );
  });

  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 to-white py-12 px-4">
      <div className="max-w-4xl mx-auto">

        {/* Heading */}
        <div className="text-center mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-3">
            Locate <span className="text-orange-500">Store</span>
          </h1>
          <div className="w-20 h-1 bg-orange-500 mx-auto"></div>
        </div>

        {/* Search */}
        <div className="bg-white rounded-xl shadow-lg p-4 mb-8">
          <div className="relative">
            <input
              type="text"
              placeholder="Search by city, area..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full px-5 py-3 pl-12 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
            />
            <FaSearch className="absolute left-4 top-3.5 text-gray-400" />
          </div>
        </div>

        {filteredStores.map((store) => (
          <div key={store.id} className="mb-10">

            {/* Map */}
            <div className="rounded-xl overflow-hidden shadow-lg mb-6">
              <iframe
                src={store.mapEmbed}
                width="100%"
                height="350"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                title="Store Location"
              ></iframe>
            </div>

            {/* Store Card */}
            <div className="bg-white rounded-xl shadow-md p-6 border-l-4 border-orange-500">
              <h3 className="text-2xl font-bold text-gray-800">
                {store.city}, {store.state}
              </h3>

              <p className="text-orange-600 font-medium text-sm">
                {store.area}
              </p>

              <p className="text-sm text-gray-600 mt-2">{store.address}</p>

              <div className="flex flex-wrap gap-6 mt-3 text-sm text-gray-500">
                <a
                  href={`tel:${store.phone.replace(/\s/g, "")}`}
                  className="flex items-center gap-2 hover:text-orange-600"
                >
                  <FaPhone className="text-orange-500" />
                  {store.phone}
                </a>

                <span className="flex items-center gap-2">
                  <FaClock className="text-orange-500" />
                  {store.hours}
                </span>
              </div>

              <a
                href={store.mapLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block mt-5 bg-orange-500 text-white px-6 py-2 rounded-lg text-sm font-semibold hover:bg-orange-600 transition-colors"
              >
                Get Directions
              </a>
            </div>

          </div>
        ))}
      </div>
    </div>
  );
};

export default LocateStorePage;